import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plain-toolbar',
  templateUrl: './plain-toolbar.component.html',
  styleUrls: ['./plain-toolbar.component.scss']
})
export class PlainToolbarComponent {
  @Input() logo_src: string = '../../../assets/img/logo/sp-logo-light.svg';
	@Input() icon_button_class: string = 'sp-icon__button-light';
}
